import { useState } from "react";
import { useParams, useLocation } from 'react-router-dom';
import { Document, Page } from 'react-pdf';

import useMount from '../../hooks/useMount';
import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import productFileApi from "../../api/productFileApi";
import authApi from "../../api/authApi";
import Pagination from "../Commons/Pagination";
import ActionButton from "../Commons/ActionButton";

import { getLabel, setLanguage } from "../../tools/Dictionary";
import Global from "../../Global/Global";
import { MdClose, MdDownload } from "react-icons/md";

import "./ProductFile.css";


const ProductFileViewer = (props) => {

  //Query
   const { id } = useParams();
  const { search  } = useLocation(); 
  const qp = new URLSearchParams(search);
  const language = qp.get('language');

  //Props
  const IsDesktop = props.IsDesktop;

  //State
  const [data, setData] = useState(undefined);
  const [media, setMedia] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [numPages, setNumPages] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const [scale] = useState(1.0);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm, setConfirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });


  useMount(() =>
  {
      setLanguage(language?.toUpperCase() || "en");
      loadData();
  }, []);


  const processAuth = async () =>
  {



      let token = localStorage.getItem(Global.apiToken);

      authApi.setRequestHeader();



  }

  const loadData = async (_showLoading = true) =>
  {

      try
      {

      await processAuth();

      if (_showLoading)
      {
          setLoading(true);
      }

      console.group("ProductFileViewer loadData", id);

      let [productFileData, downloadData] = await Promise.all([
          productFileApi.getProductFile(id),
          productFileApi.downloadProductFile(id),
      ]);

      if (productFileData.Success && downloadData)
      {

          const blob = new Blob([downloadData], {
              type: 'application/octet-stream'
          });

          setData(productFileData.Data);

          setMedia(URL.createObjectURL(blob));

          if (productFileData.Data.type != "pdf")
              setLoading(false);



      } else
          throw new Error();


      setLoading(false);

      } catch (err)
      {
      setLoading(false);


      setAlert({
          Title: getLabel("App", "Error"),
          Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
          Confirm: getLabel("App", "Ok"),
          onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
          Display: true
      });

      }

  };

  const onClickDownload = async (_showLoading = true) =>
  {

      try
      {

      await processAuth();

      if (_showLoading)
      {
          setLoading(true);
      }

      console.group("ProductFileViewer loadData", id);

      let [productFileData, downloadData] = await Promise.all([
          productFileApi.getProductFile(id),
          productFileApi.downloadProductFile(id),
      ]);

      if (productFileData.Success && downloadData)
      {

          const blob = new Blob([downloadData], {
              type: 'application/octet-stream'
          });

          console.log("blob", productFileData);

          let currentData = productFileData.Data;

          let url = URL.createObjectURL(blob);

          // Create an anchor element
          const a = document.createElement('a');
          a.href = url;
          a.download = currentData.name + "." + currentData.format;

          // Append the anchor element to the document body
          document.body.appendChild(a);

          // Programmatically trigger a click event on the anchor element to initiate the download
          a.click();

          // Cleanup: Remove the anchor element and revoke the temporary URL
          document.body.removeChild(a);
          URL.revokeObjectURL(url);

          setLoading(false);



      } else
          throw new Error();


      setLoading(false);

      } catch (err)
      {
      setLoading(false);


      setAlert({
          Title: getLabel("App", "Error"),
          Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
          Confirm: getLabel("App", "Ok"),
          onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
          Display: true
      });

      }

  };

  const onDocumentLoadSuccess = (_data) => {

      try{

      setNumPages(_data._pdfInfo.numPages);
      setLoading(false);


      }catch{

      setNumPages(0);

      }


  };


    console.log(language, "language");
  return (
    <div className="productfile_viewer_page">
        <LoadingComponent
        display={loading}
        label={getLabel("App", "Loading")}
        />
        <AlertModal
        Title={alert.Title}
        Message={alert.Message}
        Confirm={alert.Confirm}
        onConfirm={alert.onConfirm}
        Display={alert.Display}
        />
        <ConfirmModal
        Display={confirm.Display}
        Title={confirm.Title}
        Message={confirm.Message}
        Cancel={confirm.Cancel}
        onCancel={confirm.onCancel}
        Confirm={confirm.Confirm}
        onConfirm={confirm.onConfirm}
        />
        <div className="processfile_display_media_cont" style={{alignItems: "flex-start", marginTop: "50px"}}> 
          <div className="processfile_display_media_page_cont" style={{ height: "50px" }}>
            <div className="processfile_display_media_page_col" style={{width: "20%"}}>
                <ActionButton
                  IsDesktop={false}
                  Label={getLabel("FileController", "Download")}
                  Icon={MdDownload}
                  OnClick={onClickDownload}
                />
            </div>
            <div className="processfile_display_media_page_col" style={{width: "60%"}}>
              <Pagination
                IsDesktop={IsDesktop}
                data={{
                  page: pageNumber,
                  perPage: 1
                }}
                onChangePage={(_page) => setPageNumber(_page)}
                count={numPages}
              />
            </div>
            <div className="processfile_display_media_page_col" style={{width: "20%"}} />
          </div>
          <div style={{margin: "auto"}}>
            <Document 
            file={media}
            onLoadSuccess={onDocumentLoadSuccess}
            className="flex flex-col items-center"
            loading={null}
            >
            <Page pageNumber={pageNumber} scale={scale} 
            />
            </Document>
          </div>
        </div>
    </div>
  );

};

export default ProductFileViewer